import { inject, Injectable } from '@angular/core';
import { Database, onValue, ref } from '@angular/fire/database';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectionService {
  private db = inject(Database);
  isConnected$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {
    const connectedRef = ref(this.db, '.info/connected');
    onValue(connectedRef, (snapshot) => {
      this.isConnected$.next(snapshot.val() === true);
    });
  }
}
